export enum SSOState {
    SUCCESS = "SUCCESS",
    FAILURE = "FAILURE",
}
